<template>
  <BgImageLayout title="Data imports">
    <GAEdialog :value="GAEdialog" no-close-action seamless :user="user" @updated="googleAccountAdded" />

    <q-stepper v-model="step" vertical color="primary" animated header-nav active-icon="forward">
      <q-step
        :disable="isLoadingOrStepIsZeroOrGreaterThan3"
        :name="1"
        title="Select entity for which you want to import data"
        :icon="step === 3 ? 'check' : 'settings'"
        :done="step > 1"
      >
        <q-stepper-navigation class="q-gutter-sm">
          <q-stepper-navigation class="q-gutter-sm">
            <q-btn
              color="primary"
              :outline="step1Selection !== 'subscriptions'"
              label="Subscriptions"
              @click="onStep1('subscriptions')"
            />

            <q-btn
              color="primary"
              :outline="step1Selection !== 'providers'"
              label="Publishers/vendors"
              @click="onStep1('providers')"
            />
          </q-stepper-navigation>
        </q-stepper-navigation>
      </q-step>

      <q-step
        :disable="!step1Selection || isLoadingOrStepIsZeroOrGreaterThan3"
        :name="2"
        title="Import/sync data"
        :icon="step === 3 ? 'check' : 'settings'"
        :done="step > 2"
      >
        <Step3
          v-model="step"
          :selection="step1Selection"
          @complete="importCompleted"
          @import-is-loading="importIsLoading = $event"
        />
      </q-step>
    </q-stepper>

    <Banner v-if="step === 3" class="q-mt-sm" type="success" :message="successMessage">
      <q-btn outline color="white" label="See the import" class="q-mr-sm" @click="goToImportShowPage" />
      <q-btn outline color="white" label="Start new" @click="startNewImport" />
    </Banner>
  </BgImageLayout>
</template>

<script>
import DataImportsModule from './vuex/DataImports'
// Libraries
import { mapActions } from 'vuex'
// Components
import GAEdialog from '@/reusable/GAEdialog'
import Step3 from './components/Step3'
import Banner from './components/Banner'

export default {
  components: {
    GAEdialog,
    Step3,
    Banner
  },

  data: () => ({
    step: 1,
    step1Selection: null,
    successMessage: null,
    importIsLoading: false,
    GAEdialog: false,
    importId: null,
    user: null
  }),

  computed: {
    isLoadingOrStepIsZeroOrGreaterThan3() {
      return this.step > 3 || this.step === 0 || this.importIsLoading
    }
  },

  beforeCreate() {
    this.$store.registerModule('data-imports', DataImportsModule)
  },

  created() {
    this.getSpreadsheetInformation()
    if (!this.$store.state.user.google_account_email) {
      this.step = 0
      this.user = this.$store.state.user
      this.GAEdialog = true
    }
  },

  beforeDestroy() {
    this.$store.unregisterModule('data-imports')
  },

  methods: {
    ...mapActions('data-imports', ['getSpreadsheetInformation']),

    googleAccountAdded(updatedUser) {
      this.GAEdialog = false
      this.$store.commit('updateUser', updatedUser)
      this.$q.localStorage.set(`${this.$store.getters.tenant}_user`, updatedUser)
      this.step = 1
    },

    onStep1(selection) {
      this.step1Selection = selection
      this.step = 2
    },

    importCompleted({ message, importId }) {
      this.successMessage = message
      this.importId = importId
      this.step = 3
      this.importIsLoading = false
    },

    startNewImport() {
      this.step = 1
      this.step1Selection = null
      this.successMessage = null
    },

    goToImportShowPage() {
      const routes = {
        subscriptions: 'subscription-imports',
        providers: 'provider-imports'
      }
      const path = `${routes[this.step1Selection]}/${this.importId}`
      this.$router.push(path)
    }
  }
}
</script>
